/* build/tpl */
import deps from './deps/pathToString.js';
import getPathToString from './getPathToString.js';
export default getPathToString(deps);
